import { ICommentsActions } from "./actions/comments-actions/comments-actions";
import { IAuthActions } from "./actions/auth-actions/auth-actions";
import { IViewActions } from "./actions/view-actions/view-actions";
import { IEntityTagActions } from "./actions/deal-actions/tag-entity-actions";
import { createContext, useContext } from "react";

import { INewsFeedActions } from "./actions/news-feed-actions/news-feed-actions";
import { IPortfolioConstructionActions } from "./actions/portfolio-construction-actions/portfolio-construction-actions";
import { IDealModuleActions, IUserModuleActions, IUserManageActions, IReportsGroupActions } from "./actions";
import { ITaskManageActions } from "./actions/task-manage-actions/task-manage-actions";
import { IDataRoomsActions } from "./actions/data-rooms-actions/data-rooms-actions";
import { IDocumentsActions } from "./actions/documents-actions/documents-actions";
import { ITaggerActions } from "./actions/tagger-actions/tagger-actions";
import { IDebtActions } from "./actions/debt-actions/debt-actions";

export const AuthActionsContext = createContext<IAuthActions>({} as IAuthActions);
export const useAuthActions = (): IAuthActions => useContext<IAuthActions>(AuthActionsContext);

export const UserActionsContext = createContext<IUserModuleActions>({} as IUserModuleActions);
export const useUserActions = (): IUserModuleActions => useContext<IUserModuleActions>(UserActionsContext);

export const CommentsActionsContext = createContext<ICommentsActions>({} as ICommentsActions);
export const useCommentsActions = (): ICommentsActions => useContext<ICommentsActions>(CommentsActionsContext);

export const DealActionsContext = createContext<IDealModuleActions>({} as IDealModuleActions);
export const useDealActions = (): IDealModuleActions => useContext<IDealModuleActions>(DealActionsContext);

export const ViewActionsContext = createContext<IViewActions>({} as IViewActions);
export const useViewActions = (): IViewActions => useContext<IViewActions>(ViewActionsContext);

export const ReportsActionsContext = createContext<IReportsGroupActions>({} as IReportsGroupActions);
ReportsActionsContext.displayName = "Reports Actions Context";

export const useReportsActions = (): IReportsGroupActions => useContext<IReportsGroupActions>(ReportsActionsContext);

export const DebtActionsContext = createContext<IDebtActions>({} as IDebtActions);
export const useDebtActions = (): IDebtActions => useContext<IDebtActions>(DebtActionsContext);

export const TaskManageActionsContext = createContext<ITaskManageActions>({} as ITaskManageActions);

export const useTaskManageActions = (): ITaskManageActions => useContext<ITaskManageActions>(TaskManageActionsContext);

export const DataRoomsActionsContext = createContext<IDataRoomsActions>({} as IDataRoomsActions);
export const useDataRoomsActions = (): IDataRoomsActions => useContext<IDataRoomsActions>(DataRoomsActionsContext);

export const TaggerActionsContext = createContext<ITaggerActions>({} as ITaggerActions);
export const useTaggerActions = (): ITaggerActions => useContext<ITaggerActions>(TaggerActionsContext);

export const DocumentsActionsContext = createContext<IDocumentsActions>({} as IDocumentsActions);
export const useDocumentsActions = (): IDocumentsActions => useContext<IDocumentsActions>(DocumentsActionsContext);

export const UserManageActionsContext = createContext<IUserManageActions>({} as IUserManageActions);
export const useUserManageActions = (): IUserManageActions => useContext<IUserManageActions>(UserManageActionsContext);

export const PortfolioConstructionActionsContext = createContext<IPortfolioConstructionActions>(
  {} as IPortfolioConstructionActions
);
export const usePortfolioConstructionActions = (): IPortfolioConstructionActions =>
  useContext<IPortfolioConstructionActions>(PortfolioConstructionActionsContext);

export const EntityTagActionsContext = createContext<IEntityTagActions>({} as IEntityTagActions);
export const useEntityTagActions = (): IEntityTagActions => useContext<IEntityTagActions>(EntityTagActionsContext);

export const NewsFeedActionsContext = createContext<INewsFeedActions>({} as INewsFeedActions);
export const useNewsFeedActions = (): INewsFeedActions => useContext<INewsFeedActions>(NewsFeedActionsContext);
